module.exports = __webpack_public_path__ + "images/waaijenberg81564b1c0261a96eb3db45d8155008a0.png";